import { render, staticRenderFns } from "./LegalCaseEditorEngagementLetter.vue?vue&type=template&id=36be6800&"
import script from "./LegalCaseEditorEngagementLetter.vue?vue&type=script&lang=js&"
export * from "./LegalCaseEditorEngagementLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports